import { getFilterVariantState, type IFilterItem } from "@next-platform/client-common-spicy-ui";

import { FILTER_SECTION_V2_ORDER, FilterSectionV2Id } from "./FilterSectionV2Id";
import type { AppliedFilterChipData } from "./types";

type GetAppliedFilterChipsParams = {
  sectionItems: Partial<Record<FilterSectionV2Id, IFilterItem[]>>;
};

const createAppliedFilterChip = (sectionId: FilterSectionV2Id, filterOption: IFilterItem): AppliedFilterChipData => ({
  key: `${sectionId}:${filterOption.value}`,
  sectionId,
  value: filterOption.value,
  label: filterOption.label,
  isExcluded: getFilterVariantState(filterOption.variant).isExcluded,
});

const getAppliedFilterChips = ({ sectionItems }: GetAppliedFilterChipsParams): AppliedFilterChipData[] =>
  FILTER_SECTION_V2_ORDER.flatMap((sectionId) =>
    (sectionItems[sectionId] ?? [])
      .filter((filterOption) => getFilterVariantState(filterOption.variant).isSelected)
      .map((filterOption) => createAppliedFilterChip(sectionId, filterOption)),
  );

export default getAppliedFilterChips;
